/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { NavLink } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import 'components/nav.scss';

export default function ExploreNav(props){

  return(
    <nav className='subnav'>
        <NavLink exact to='/client/tools/metrics' activeClassName='active'>
          <FeatherIcon icon="check-square" size={16} className="icon" /> Metrics
        </NavLink>
        {/* <NavLink exact to='/app/explore/reports' activeClassName='active'>
          <FeatherIcon icon="file-text" size={16} className="icon" /> Reports
        </NavLink> */}
        <NavLink exact to='/client/tools/export' activeClassName='active'>
          <FeatherIcon icon="layout" size={16} className="icon" /> Exports
        </NavLink>
      </nav>
  );
}
